// client/src/util/useMobileCheck.js
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import is from 'is_js';

const useMobileCheck = () => {
  const [ isMobile, setIsMobile ] = useState(false);
  const [ isPortrait, setIsPortrait ] = useState(false);
  const [ isHelpPage, setIsHelpPage ] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const portrait = window.innerHeight > window.innerWidth;
      const isTablet = is.touchDevice() && ( is.linux() || is.mac() ) && !is.mobile();
      const mobile =  ( ( isTablet ) && portrait ) || is.mobile();
      setIsMobile(mobile);
      setIsPortrait(portrait);
    };
    handleResize()

    window.addEventListener("orientationchange", handleResize );
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  useEffect( () => { 
    if ( location.pathname === "/help" ) { 
      setIsHelpPage(true)
    } else { 
      setIsHelpPage(false);
    }
  }, [ location ])

  // iOS : { is.ios() ? 'YES' : 'NO' }, 
  // chrome : { is.not.safari() && is.not.ie() && is.not.firefox() && is.not.edge() && is.not.opera() && is.not.phantom() ? 'YES' : 'NO' }, 
  // iPad : { is.ipad() ? 'YES' : 'NO' }, 
  // mobile : { isMobile ? 'YES' : 'NO' }

  return { 
    // sizes
    
    isPortrait,
    isMobile,
    isDesktop: is.desktop(),
    isSmall : is.mobile(), 
    isIPad : is.ipad(),
    isIPhone : is.iphone(),
    isAndroidPhone : is.androidPhone(),
    isTablet : is.tablet(),
    isTouchDevice : is.touchDevice(),
    
    // operating systems
    isIOS: is.ios(),
    isAndroid : is.android(),
    isWindows: is.windows(),
    isMac: is.mac(),
    isLinux: is.linux(),
    
    // browsers
    isSafari: is.safari(),
    isIE : is.ie(),
    isFirefox : is.firefox(),
    isEdge : is.edge(),
    isOpera : is.opera(),
    isPhantom : is.phantom(),
    isChrome : ( is.not.safari() && is.not.ie() && is.not.firefox() && is.not.edge() && is.not.opera() && is.not.phantom() ),
    
    // other
    hasShortcuts : !( is.touchDevice() || is.mobile() || is.ios() || is.android() ),
    allowFullScreen : is.touchDevice() && ( is.linux() || is.mac() ) && !is.mobile(),

    isHelpPage
  };
};

export default useMobileCheck;